<template>
  <header id="header">
    <div class="header-bg">
      <div class="-default"></div>
      <div class="-mario"></div>
      <div class="-admin"></div>
      <div class="-confianca"></div>
      <div class="-desbravando"></div>
    </div>

    <div class="header-container">
      <div class="header-breadcrumb">
        <router-link to="/" title="Home">
          <!-- <img
            src="../assets/img/Logo8i_blanco.png"
            alt="logo-8i"
            class="logo-class"
            style="width: 100px; position: relative; width: 100px; top: 7px"
        /> -->

          <div style="width: 100px; display: flex; flex-flow: row nowrap; position: relative; top: 3px">
            <img
              src="../assets/img/logo-parte1.png"
              alt="logo-8i"
              class="logo-class"
              id="logo-parte1"
              style="width: 59px"
            />
            <img
              src="../assets/img/logo-parte2.png"
              alt="logo-8i"
              class="logo-class"
              id="logo-parte2"
              style="width: 41px; transition: opacity 0.3s ease-out"
            />
          </div>
        </router-link>
      </div>

      <button
        v-if="viewport.is768"
        title="Open menu"
        type="button"
        class="header-nav-button"
        @click="openMenu"
      >
        <span class="label">Menu</span>

        <span class="dots d1"></span>
        <span class="dots d2"></span>
        <span class="dots d3"></span>
      </button>

      <nav class="header-nav">
        <button
          v-if="viewport.is768"
          title="Close menu"
          type="button"
          class="header-nav-close-button"
          @click="closeMenu"
        >
          <span class="label">✕</span>
        </button>

        <ul>
          <li><router-link to="/#quienes-somos" title="Nosotros">Nosotros</router-link></li>
          <li><router-link to="/#servicios" title="Servicios">Servicios</router-link></li>
          <li><router-link to="/#contactanos" title="Contacto">Contáctenos</router-link></li>

          <!-- <li class="social-link">
            <a href="https://github.com/iuridepaula" target="_blank" title="GitHub">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="ico"
                viewBox="0 0 16 16"
                role="img"
                aria-labelledby="GithubIcoTitle"
              >
                <title id="GithubIcoTitle">GitHub logo</title>
                <path
                  fill-rule="evenodd"
                  d="M8 0C3.6 0 0 3.6 0 8c0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4v-1.4c-2.2.5-2.7-1.1-2.7-1.1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.2 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6 0 1.3-.1 2-.1s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.3.6.8.6 1.5v2.2c0 .2.1.5.6.4C13.7 14.5 16 11.5 16 8c0-4.4-3.6-8-8-8z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </li> -->
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import "@/styles/header.scss";

export default {
  name: "Header",
  props: {
    routeName: String,
    viewport: Object,
  },
  methods: {
    openMenu() {
      document.body.classList.add("-open-nav");
    },
    closeMenu() {
      document.body.classList.remove("-open-nav");
    },
  },
};
</script>
